import React, { Fragment } from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Homepage from "./homepage/index";
import Programs from "./homepage/Programs";
import Membership from "./homepage/Membership";
import About from "./homepage/About";
import Contact from "./homepage/Contact";
import Faq from "./homepage/Faq";
import Trainers from "./homepage/Trainers";
import Terms from "./homepage/Terms";

const Index = (props) => {
  return (
    <Fragment>
      <Router>
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route exact path="/faqs">
            <Programs />
          </Route>
          <Route exact path="/membership">
            <Membership />
          </Route>
          <Route exact path="/about">
            <About />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
          <Route exact path="/faq">
            <Faq />
          </Route>
          <Route exact path="/books">
            <Trainers />
          </Route>
          <Route exact path="/terms">
            <Terms />
          </Route>
        </Switch>
      </Router>
    </Fragment>
  );
};

export default Index;
